module.exports = __webpack_public_path__ + "img/File.792e18d5.svg";